import { render, staticRenderFns } from "./TsEdicola.vue?vue&type=template&id=193f5550&scoped=true"
import script from "./TsEdicola.vue?vue&type=script&lang=js"
export * from "./TsEdicola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f5550",
  null
  
)

export default component.exports